import classNames from 'classnames';
import { FixedLengthArray, LegendColorBarValuesOverDivision } from 'components/legends/legend-flex-division.js';
import { WeatherStationLocationType } from 'types/markerTypes/marker.weatherStation.js';
import { predicateNumber } from 'utilities/isType.js';
import { getSoilData } from './station-utils-soil.js';
import { getBackgroundColor } from './utils.js';

export const getSoilTemp = (value: WeatherStationLocationType['value']) => {
  const soil = getSoilData(value);
  if (soil) {
    return soil.temperature;
  }
  return undefined;
};

export const WeatherStationSoilTempChild = ({
  value,
  selected,
}: {
  value: WeatherStationLocationType['value'];
  selected?: boolean;
}) => {
  const temp = getSoilTemp(value);
  if (predicateNumber(temp)) {
    return (
      <div className="Map-pin-content-text">
        <span className={`${classNames({ 'u-textDefault': !selected })}`}>{`${temp}°`}</span>
      </div>
    );
  }
  return null;
};

export const colorSoilTempRange: [number, string][] = [
  [0, '#0387C7'],
  [5, '#03B3CA'],
  [10, '#189B4A'],
  [15, '#A2DD4C '],
  [20, '#E7E080'],
  [25, '#FA9D6E '],
  [30, '#D5372E'],
  [35, '#730808'],
];

/* We return the lowest one by default */
export const getBackgroundColorSoilTemperature = getBackgroundColor(colorSoilTempRange);

export const KeyBarSoilTemperature = () => {
  /** The key temp guage gives color on basis of if temp is in range. 0 is the bottom range so we miss this out
   * As we want values over the divisions
   */
  const vals = ['-5', ...colorSoilTempRange.map(([n, _]) => n)] as FixedLengthArray<string, 9>;
  const colors = colorSoilTempRange.map(([_, v]) => v) as FixedLengthArray<string, 8>;
  return <LegendColorBarValuesOverDivision vals={vals} colors={colors} valsClasses="u-textBold" />;
};
